import {
    isBik,
    isCorrespondentAccount,
    isCyrillic,
    isCyrillicFio,
    isEmail,
    isIndividualOgrn,
    isIndividualInn,
    isInn,
    isKpp,
    isMinLength,
    isOgrn,
    isPaymentAccount,
    isPhone,
    isPost,
    isRequired,
    validate
} from '../../../services/validator';

function isMinNameLength(val) {
    return isMinLength(val, 2);
}

export function validateForm(values) {
    const rules = {
        inn: [(val) => values.activityType == 1
            ? isInn(val)
            : isIndividualInn(val)
            , isRequired],
        bik: [isBik, isRequired],
        bankName: [isRequired],
        paymentAccount: [isPaymentAccount, isRequired],
        correspondentAccount: [isCorrespondentAccount, isRequired],
        // Контактное лицо
        contactEmail: [isEmail, isRequired],
        contactFio: [isRequired,
            isCyrillicFio,
            (val) => isMinLength(val, 4)],
        contactPhone: [isPhone, isRequired],
        addressPost: [isRequired],
        addressUr: [isRequired]
    };

    if (values.activityType == 1) {
        // Данные подписанта
        rules.orgName = [isRequired];
        rules.post = [isPost, isRequired];
        rules.basisPost = [isRequired];
        rules.lastName = [isCyrillic, isMinNameLength, isRequired];
        rules.firstName = [isCyrillic, isMinNameLength, isRequired];
        rules.middleName = [isCyrillic, isMinNameLength, isRequired];

        rules.kpp = [isKpp, isRequired];
        rules.ogrn = [isOgrn, isRequired];
    }

    if (values.activityType == 2) {
        rules.ogrn = [isIndividualOgrn, isRequired];
    }
    
    const errors = validate(values, rules);

    return errors;
}


// WEBPACK FOOTER //
// ./src/modules/home/profile/validate.js